import { matchRoute } from '../utils/routeUtils';

// An element page needs at least this many words of real written prose before it is worth indexing.
export const MIN_INDEXABLE_PROSE_WORDS = 150;

/**
 * Decides which pages search engines should index. Thin pages are still served and linked,
 * but get a noindex robots tag, stay out of the sitemap and show no ads.
 */
export default class PageIndexingPolicy {
  constructor({ indexableElementSlugs = [] } = {}) {
    this.indexableElementSlugs = new Set(indexableElementSlugs);
  }

  isElementPageIndexable(slug) {
    return this.indexableElementSlugs.has(slug);
  }

  // Every famous reaction page has its own hand-written explanation, so they all stay indexable.
  isReactionPageIndexable() {
    return true;
  }

  isPathIndexable(path) {
    const route = matchRoute(path);
    if (route.page === 'not-found') return false;
    if (route.page === 'element') return this.isElementPageIndexable(route.slug);
    if (route.page === 'reaction') return this.isReactionPageIndexable(route.slug);
    // Answer keys are short lists that only make sense next to their worksheet.
    if (route.page === 'worksheet-answers') return false;
    return true;
  }

  filterIndexablePaths(paths) {
    return paths.filter((path) => this.isPathIndexable(path));
  }
}
